var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28637_44473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28637_44473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 14.6665L10.0001 11.6665L13.0001 14.6665L14.1667 13.4998L11.1667 10.4998L14.1667 7.49984L13.0001 6.33317L10.0001 9.33317L7.00008 6.33317L5.83342 7.49984L8.83342 10.4998L5.83342 13.4998L7.00008 14.6665ZM10.0001 18.8332C8.8473 18.8332 7.76397 18.6144 6.75008 18.1769C5.73619 17.7394 4.85425 17.1457 4.10425 16.3957C3.35425 15.6457 2.7605 14.7637 2.323 13.7498C1.8855 12.7359 1.66675 11.6526 1.66675 10.4998C1.66675 9.34706 1.8855 8.26373 2.323 7.24984C2.7605 6.23595 3.35425 5.354 4.10425 4.604C4.85425 3.854 5.73619 3.26025 6.75008 2.82275C7.76397 2.38525 8.8473 2.1665 10.0001 2.1665C11.1529 2.1665 12.2362 2.38525 13.2501 2.82275C14.264 3.26025 15.1459 3.854 15.8959 4.604C16.6459 5.354 17.2397 6.23595 17.6772 7.24984C18.1147 8.26373 18.3334 9.34706 18.3334 10.4998C18.3334 11.6526 18.1147 12.7359 17.6772 13.7498C17.2397 14.7637 16.6459 15.6457 15.8959 16.3957C15.1459 17.1457 14.264 17.7394 13.2501 18.1769C12.2362 18.6144 11.1529 18.8332 10.0001 18.8332ZM10.0001 17.1665C11.8612 17.1665 13.4376 16.5207 14.7292 15.229C16.0209 13.9373 16.6667 12.3609 16.6667 10.4998C16.6667 8.63873 16.0209 7.06234 14.7292 5.77067C13.4376 4.479 11.8612 3.83317 10.0001 3.83317C8.13897 3.83317 6.56258 4.479 5.27092 5.77067C3.97925 7.06234 3.33341 8.63873 3.33341 10.4998C3.33341 12.3609 3.97925 13.9373 5.27092 15.229C6.56258 16.5207 8.13897 17.1665 10.0001 17.1665Z",
    fill: "#F24822"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.628af828f0a6ddfb915c3e991657d210.svg";
export { ForwardRef as ReactComponent };